@if (tenderDetailsResource.isLoading()) {
  <app-loading />
} @else if (tenderDetailsResource.value()) {
  @let tenderDetails = tenderDetailsResource.value()!;
  <app-wizard-phase-header
    [phase]="'RFC'"
    [companyName]="tenderDetails.companyName"
    [projectName]="tenderDetails.projectName"
  />

  <p-tabs
    appTabsUnsavedReveal
    [value]="activeTabIndex()"
    (valueChange)="onTabChange($event!)"
    [lazy]="false"
  >
    <p-tablist>
      <p-tab [value]="TAB_INDICES.MAIL_PREVIEW" [appTabStatus]="mailPreviewTabStatus()">
        {{ 'provider.tenderWizard.rfq.mailPreview' | transloco }}
      </p-tab>
      <p-tab [value]="TAB_INDICES.PROJECT_CONCLUSION" [appTabStatus]="projectConclusionTabStatus()">
        {{ 'provider.tenderWizard.rfq.projectParameters' | transloco }}
      </p-tab>
    </p-tablist>

    <p-tabpanels class="mt-6">
      <p-card class="bg-(--p-surface-900) border-none">
        <p-tabpanel [value]="TAB_INDICES.MAIL_PREVIEW">
          <app-tender-invitation-mail
            [tenderDetails]="tenderDetails"
            (nextTab)="onTabChange(TAB_INDICES.PROJECT_CONCLUSION)"
          />
        </p-tabpanel>

        <p-tabpanel [value]="TAB_INDICES.PROJECT_CONCLUSION">
          <app-tender-project-rfc-project-conclusion [tenderDetails]="tenderDetails" />
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
}
